import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language].footer;

  return (
    <footer className="seccion-footer">
      <div className="container-footer">
        <div className="footer-left">
          <div className="footer-information">
            <div className="footer-block-three">
              <img src="/images/mail-white.svg" width={26} alt="email" className="image-footer" />
              <a href={`mailto:${t.email}`} className="footer-link-three">{t.email}</a>
            </div>
            <div className="footer-block-three">
              <img src="/images/maps-white.svg" width={26} alt="location" className="image-footer" />
              <a href="#" className="footer-link-three">{t.address}</a>
            </div>
            <div className="footer-social-block-three">
              <img src="/images/phone-white.svg" width={26} alt="phone" className="image-footer" />
              <a href={`tel:${t.phone}`} className="footer-link-three">{t.phone}</a>
            </div>
          </div>
        </div>

        <div className="footer-information">
          <div className="footer-block-three">
            <a href="#" className="footer-link-three">© 2025 CastleTech LLC</a>
          </div>
          <div className="footer-social-block-three">
            <a href="#" className="icon-footer w-inline-block">
              <img src="/images/facebook-white.svg" width={26} alt="Facebook" className="image-footer" />
            </a>
            <a href="#" className="icon-footer w-inline-block">
              <img src="/images/instagram-white.svg" width={26} alt="Instagram" className="image-footer" />
            </a>
            <a href="#" className="icon-footer w-inline-block">
              <img src="/images/twitter-white.svg" width={26} alt="Twitter" className="image-footer" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;